import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CountryProvider } from "@/lib/countryContext";
import { ADMIN_PATH } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import RequireAuth from "@/components/RequireAuth";
import AuthAwareHome from "@/components/AuthAwareHome";
import OverviewPage from "@/pages/Overview";
import BuildersPage from "@/pages/Builders";
import ManufacturersPage from "@/pages/Manufacturers";
import AssociationsPage from "@/pages/Associations";
import MatchesPage from "@/pages/Matches";
import OutreachPage from "@/pages/Outreach";
import SentHistoryPage from "@/pages/SentHistory";
import ProductsPage from "@/pages/Products";
import InvoicesPage from "@/pages/Invoices";
import TermsPage from "@/pages/Terms";
import AdminLoginPage from "@/pages/AdminLogin";

function App() {
  useEffect(() => {
    document.title = "Helios / Leads — EU Solar Prospecting Engine";
  }, []);

  return (
    <CountryProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin login is at a secret URL — bare page, no layout */}
          <Route path={ADMIN_PATH} element={<AdminLoginPage />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                {/* Public buyer-facing pages */}
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/terms" element={<TermsPage />} />
                {/* Root: public landing for buyers, admin overview when logged in */}
                <Route path="/" element={<AuthAwareHome />} />
                {/* Admin dashboard — all gated by RequireAuth */}
                <Route path="/builders" element={<RequireAuth><BuildersPage /></RequireAuth>} />
                <Route path="/manufacturers" element={<RequireAuth><ManufacturersPage /></RequireAuth>} />
                <Route path="/associations" element={<RequireAuth><AssociationsPage /></RequireAuth>} />
                <Route path="/matches" element={<RequireAuth><MatchesPage /></RequireAuth>} />
                <Route path="/outreach" element={<RequireAuth><OutreachPage /></RequireAuth>} />
                <Route path="/history" element={<RequireAuth><SentHistoryPage /></RequireAuth>} />
                <Route path="/invoices" element={<RequireAuth><InvoicesPage /></RequireAuth>} />
              </Routes>
            </Layout>
          } />
        </Routes>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #0A0A0A",
              boxShadow: "3px 3px 0px #0A0A0A",
              fontFamily: "'IBM Plex Sans', sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </CountryProvider>
  );
}

export default App;
